import { interaction, Stack, XStack, YStack, YStackProps } from '@mythical/ui'
import { PlanLevel } from 'app/constants/tiers'
import { Tier } from 'app/queries/tiers/member-tiers'
import { SizableText } from 'tamagui'

const TIER_DESCRIPTIONS: Record<PlanLevel, string> = {
  1: 'For the Mythical Beast who wants more.',
  2: 'For the Mythical Beast who wants it all.',
}

export interface TierCardProps extends YStackProps {
  isSelected: boolean
  onPress: () => void
  price: string
  tier: Tier
  disabled?: boolean
}

export const TierCard = ({
  isSelected,
  onPress,
  price,
  tier,
  disabled,
  ...props
}: TierCardProps) => {
  const description = TIER_DESCRIPTIONS[tier.planLevel]

  return (
    <YStack
      bg={isSelected ? '$bgSecondary_op80' : '$transparent'}
      borderColor={isSelected ? '$borderPrimary' : '$borderSecondary'}
      borderWidth="$1"
      br="$3.5"
      px="$3.5"
      py="$5"
      opacity={disabled ? 0.5 : 1}
      {...(!disabled && {
        cursor: 'pointer',
        ...interaction.opacity,
        onPress,
      })}
      {...props}
    >
      <XStack gap="$3.5" ai="center">
        <Stack
          ai="center"
          borderColor={isSelected ? '$borderPrimary' : '$fgSecondary'}
          borderWidth="$1"
          br={12}
          h={24}
          jc="center"
          w={24}
        >
          {isSelected && <Stack w={12} h={12} br={6} bg="$borderPrimary" />}
        </Stack>

        <YStack f={1} gap="$3">
          <SizableText size="$6.5" fontWeight="600">
            {tier.name}
          </SizableText>
          <SizableText
            size="$1"
            fontWeight="500"
            color="$fgSecondary"
            $gtSm={{ color: '$fgPrimary' }}
          >
            {description}
          </SizableText>
        </YStack>

        <SizableText size="$2" fontWeight="500" whiteSpace="nowrap">
          {price}
        </SizableText>
      </XStack>
    </YStack>
  )
}
